(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["p4p-external-links"] && !Shopify.designMode) return;
  try {
    (() => {
  const settings = document.getElementById('P4PExternalLinkSettings');
  if (!settings || settings.dataset.initialized === 'true') return;
  settings.dataset.initialized = 'true';
  const internalHosts = new Set([
    window.location.hostname,
    'patternsforpirates.com',
    'www.patternsforpirates.com',
    'vault.patternsforpirates.com',
  ]);
  [settings.dataset.shopUrl, `https://${settings.dataset.shopDomain}`].forEach((value) => {
    try { internalHosts.add(new URL(value).hostname); } catch (_) {}
  });
  let accountUrl;
  try { accountUrl = new URL(settings.dataset.accountUrl, document.baseURI); } catch (_) {}
  const originals = new WeakMap();
  const messageId = 'a11y-new-window-message';
  const attributes = ['target', 'rel', 'aria-describedby'];
  const tokens = (value) => (value || '').split(/\s+/).filter(Boolean);
  const isExternal = (link) => {
    if (link.hasAttribute('download')) return false;
    let url;
    try { url = new URL(link.getAttribute('href'), document.baseURI); } catch (_) { return false; }
    if (!['http:', 'https:'].includes(url.protocol) || internalHosts.has(url.hostname)) return false;
    const accountPath = `/${settings.dataset.shopId}/account`;
    if (url.hostname === 'shopify.com' && (url.pathname === accountPath || url.pathname.startsWith(`${accountPath}/`))) return false;
    if (accountUrl && accountUrl.pathname !== '/' && url.origin === accountUrl.origin &&
      (url.pathname === accountUrl.pathname || url.pathname.startsWith(`${accountUrl.pathname}/`))) return false;
    return true;
  };
  const restore = (link) => {
    const state = originals.get(link);
    if (!state) return;
    attributes.forEach((name) => {
      if (link.getAttribute(name) !== state.applied[name]) return;
      if (state.before[name] === null) link.removeAttribute(name);
      else link.setAttribute(name, state.before[name]);
    });
    originals.delete(link);
  };
  const update = (link) => {
    if (!link.hasAttribute('href') || !isExternal(link)) { restore(link); return; }
    let state = originals.get(link);
    if (!state) {
      state = { before: {}, applied: {} };
      attributes.forEach((name) => { state.before[name] = link.getAttribute(name); });
      originals.set(link, state);
    }
    link.setAttribute('target', '_blank');
    const rel = tokens(link.getAttribute('rel')).filter((token) => token.toLowerCase() !== 'opener');
    if (!rel.some((token) => token.toLowerCase() === 'noopener')) rel.push('noopener');
    link.setAttribute('rel', rel.join(' '));
    if (document.getElementById(messageId)) {
      const descriptions = tokens(link.getAttribute('aria-describedby'));
      if (!descriptions.includes(messageId)) descriptions.push(messageId);
      link.setAttribute('aria-describedby', descriptions.join(' '));
    }
    attributes.forEach((name) => { state.applied[name] = link.getAttribute(name); });
  };
  const scan = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.matches?.('a[href]')) update(root);
    root.querySelectorAll('a[href]').forEach(update);
  };
  scan(document);
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') {
        if (record.target.matches('a')) update(record.target);
      }
      else record.addedNodes.forEach(scan);
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'download'] });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["p4p-free-pattern-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('p4p-free-pattern-request')) {
    customElements.define('p4p-free-pattern-request', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.status = this.querySelector('[role="status"]');
        this.button = this.form.querySelector('button[type="submit"]');
        this.endpoint = null;
        this.button.disabled = true;
        this.controller = new AbortController();
        this.form.addEventListener('submit', event => this.submitRequest(event), { signal: this.controller.signal });
        try {
          const service = new URL(this.dataset.serviceUrl);
          if (service.protocol !== 'https:' || service.username || service.password || service.search || service.hash || service.pathname !== '/') throw new Error('Unavailable');
          this.endpoint = new URL('/api/free-patterns/request', service).href;
          this.button.disabled = false;
        } catch {
          this.status.textContent = this.dataset.errorMessage;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
      async submitRequest(event) {
        event.preventDefault();
        if (this.pending || !this.endpoint || !this.form.reportValidity()) return;
        const fields = new FormData(this.form);
        if (fields.get('consentAccepted') !== 'on') return;
        this.pending = true;
        this.button.disabled = true;
        this.button.textContent = this.dataset.sendingMessage;
        this.form.setAttribute('aria-busy', 'true');
        this.status.textContent = '';
        try {
          const response = await fetch(this.endpoint, {
            method: 'POST', mode: 'cors', credentials: 'omit', redirect: 'error', cache: 'no-store', referrerPolicy: 'no-referrer',
            headers: { 'Content-Type': 'application/json' }, signal: AbortSignal.timeout(15000),
            body: JSON.stringify({ email: String(fields.get('email') || '').trim(), handle: this.dataset.handle, consentVersion: this.dataset.consentVersion, consentAccepted: true, company: String(fields.get('company') || '') })
          });
          if (response.status !== 202) throw new Error('Unavailable');
          const result = await response.json();
          if (!result || typeof result.message !== 'string') throw new Error('Unavailable');
          this.status.textContent = this.dataset.successMessage;
          this.form.hidden = true;
        } catch {
          this.status.textContent = this.dataset.errorMessage;
        } finally {
          this.pending = false;
          this.button.disabled = false;
          this.button.textContent = this.dataset.submitMessage;
          this.form.removeAttribute('aria-busy');
          if (this.isConnected) this.status.focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
